export default __webpack_public_path__ + "05181227cacb995021a19035f4e313e2.png";